/**
 * HubBrandMark — the Peace dove mark (Phase X.5.1).
 *
 * Renders the single-color dove SVG from src/lib/hubLogos.ts. The dove
 * uses fill="currentColor", so the rendered color follows the CSS `color`
 * of this element — cream on the sage nav, or any brand color on a tile
 * chip. The markup is a trusted static asset (not user input), so
 * dangerouslySetInnerHTML is the intended render path per the hubLogos
 * module contract.
 */

import { type CSSProperties, type ReactNode } from 'react';
import { DOVE_SVG } from '@/lib/hubLogos';

export interface HubBrandMarkProps {
  className?: string;
  /** Inline style; set `color` here to recolor the dove (currentColor). */
  style?: CSSProperties;
  /** Accessible label; defaults to "Peace". Pass "" to mark decorative. */
  label?: string;
}

export function HubBrandMark({ className, style, label = 'Peace' }: HubBrandMarkProps): ReactNode {
  const decorative = label === '';
  return (
    <span
      className={className}
      style={style}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative ? true : undefined}
      // DOVE_SVG is a trusted static brand asset (src/lib/hubLogos.ts).
      dangerouslySetInnerHTML={{ __html: DOVE_SVG }}
    />
  );
}
